const environment = process.env.VUE_APP_SERVER;

/**
 * Note: These constants are for non-sensitive information
 * such as URLs for redirection only. In the case that the env
 * variable reading fails, production variables are used
 * by default
 */

import FILES from './files';

export * from './upsell'
export * from './files'

export const FORMA_CODE = {
  FORMAT: 'NNNNN-NNNNN',
};

export const BFCM = {
  START_DATE_2025: 'November 24, 2025 11:59 PM',
  TEST_START_OVERRIDE: null,
}

export const PORTAL_CAMPAIGN_BANNER = {
  START_DATE: 'May 1, 2026 11:59 PM',
  TEST_START_OVERRIDE: null,
}

export const COOKIES = {
  SHOW_PROMO_FORM: {
    KEY: 'feature',
    VALUE: 'checkoutform',
    COOKIE_NAME: 'show_promo_form',
    COOKIE_DURATION: '30d', // 1 month
  },

  COOKIE_DOMAIN: '.bywinona.com',

  // URL-param attribution storage (growth spec). TTL = ms-string for @/utils/cookies wrapper.
  TRACKING: {
    FB_CLICK_ID:      { PARAM: 'fbclid',    NAME: 'winona_fbclid',          TTL: '90d' },
    PINTEREST_CLICK:  { PARAM: 'epik',      NAME: 'winona_epik',            TTL: '90d' },
    TWITTER_CLICK:    { PARAM: 'twclid',    NAME: 'winona_twclid',          TTL: '90d' },
    GOOGLE_CLICK_ID:  { PARAM: 'gclid',     NAME: 'winona_gclid',           TTL: '90d' },
    TIKTOK_CLICK_ID:  { PARAM: 'ttclid',    NAME: 'winona_ttclid',          TTL: '90d' },
    TABOOLA_CLICK_ID: { PARAM: 'click-id',  NAME: 'winona_tbclid',          TTL: '90d' },
    IMPACT_CLICK_ID:  { PARAM: 'irclickid', NAME: 'irclickid',              TTL: '20d' },
    MARKETING_UTMS:   {                     NAME: 'winona_utms',            TTL: '30d' },
    FIRST_TOUCH_UTMS: {                     NAME: 'winona_firsttouch_utms', TTL: '10d' },
  },

  // Last-authenticated user ID. Kept on logout, overwritten on next login. Temporary (BFCM).
  CLIENT_REF: { NAME: 'client_ref', TTL: '60d' },
};

export const DATADOG = {
  APPLICATION_ID: 'ba42f9d0-269f-42f1-84ea-536aab48a694',
  CLIENT_TOKEN: 'pub383eda3ff63fc1b84588b8184c561fc6',
  SITE: 'us5.datadoghq.com',
  SERVICE: `${environment}:client-dashboard`,
};

export const TYPING_INDICATOR = {
  THROTTLE_TIME: 800,
};

export default Object.freeze(
  environment === 'staging'
    ? {
      COOKIES,
      DATADOG,
      FILES,
      KINDRA_URL: 'https://bywinona.com/kindra',
      WEBSITE_URL: 'https://staging.winona.workers.dev',
      OFFBOARDING_URL: 'https://staging-nuxt3.bywinona.com/other-offers',
    }
    : {
      COOKIES,
      DATADOG,
      FILES,
      KINDRA_URL: 'https://bywinona.com/kindra',
      WEBSITE_URL: 'https://bywinona.com',
      OFFBOARDING_URL: 'https://bywinona.com/other-offers'
    }
);
